import React from "react";
import NavLink from "../components/NavLink";
import "../styles/lesson.css";
import ReactHtmlParser from "react-html-parser";
import ContentLoader from "../components/ContentLoader";
import {translate} from '../containers/i18n';
import { defaultLang }  from '../components/common/Constants';
import * as Pictures from '../containers/svg/';

class Sheet extends React.Component {
  constructor(props) {
    super(props);

    this.onLoadComplete = this.onLoadComplete.bind(this);
    this.updateSheetContent = this.updateSheetContent.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.replaceTags = this.replaceTags.bind(this);

    this.state = {
      htmlContent: null,
      height: window.innerHeight,
      width: window.innerWidth
    };

    this.lang = this.props.lang || defaultLang;
  }

  updateDimensions() {
    this.setState(
      {
        height: window.innerHeight,
        width: window.innerWidth
      },
      () => this.updateSheetContent()
    );
  }

  updateSheetContent() {
    const d = document.getElementById("sheet");

    if (d) {
      const h = this.state.htmlContent ? d.clientHeight + 512 : 1000;
      console.log("updateSheetContent", h, this.props.updateContainerHeight);
      if (this.props.updateContainerHeight) this.props.updateContainerHeight(h);
    } else {
      setTimeout(this.updateLessonContent, 150);
    }
  }

  componentDidMount() {
    this.props.setSheetId(this.props.sheetId);
    window.addEventListener("resize", this.updateDimensions);
  }

  onLoadComplete(data) {
    const page = ReactHtmlParser(data);
    this.setState({ htmlContent: page }, ()=> console.log("SHEET page ?", page));
  }

  render() {
    if (this.props.sheetId) {
      let content = this.state.htmlContent;
      const index = this.props.sheetId.slice(-1);
      this.updateSheetContent();

      return (
        <ContentLoader id={this.props.sheetId} lang={this.props.lang} url={(this.props.lang || defaultLang) +"/sheets/"} onComplete={this.onLoadComplete}>
          <article id="sheet" className="sheet">
            <hr className="stars"></hr>
            <h1 class="sheetTitle">{this.props.t("menu2item" + index)}</h1>
            <hr className="stars"></hr>
            {content && this.replaceTags(content)}
            <div className="backSheetButton">
              <NavLink to="../../../technique">{this.props.t("backMenu2")}</NavLink>
            </div>
            <hr className="stars"></hr>
          </article>
        </ContentLoader>
      );
    } else {
      return (
        <div></div>
      );
    }
  };

  replaceTags(content) {
    if (content) {
      return content[0].props.children.map(comp => {
        if (comp.type === "svg" && comp.props.id) {
          switch(comp.props.id) {
            case "PontDiv": return <div className="image"><Pictures.PontDiv t={this.props.t}/></div>
            default : return <div />
          }
          
        }
        else return comp;
      })
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
}

export default translate(Sheet);
